import http from '../../../axios'

export let get_deposit_record = (params = '') =>
  http.post('/deposit/get-deposit-record', params)
